module.exports = __webpack_public_path__ + "static/AvenirLTProBookOblique-aa22f0e05e465162ee269ab70df6b562.woff";